import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';
import TankCreateForm from '~/containers/tankCreate/tankCreate';

export class TankCreatePage extends Component {
  render() {
    const cancelButton = (
      <Link to={`/tanks`}>
        <Button color="secondary">Cancel</Button>
      </Link>
    );

    return (
      <Page>
        <TitleBar back="/tanks" backText="Tanks" title="Add tank" button={cancelButton} />
        <TankCreateForm />
      </Page>
    );
  }
}

export default connect(state => ({
  brewery: state.brewery
}))(withRouter(TankCreatePage));



// WEBPACK FOOTER //
// ./src/pages/tankCreate/tankCreate.jsx